<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表类型')">
              <a-input :placeholder="$t('请输入表类型')" v-model="queryParam.meterType"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备ID')">
              <a-input :placeholder="$t('请输入设备ID')" v-model="queryParam.deviceId"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('15位IMEI')">
                <a-input :placeholder="$t('请输入15位IMEI代表表ID')" v-model="queryParam.meterId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('信号强度')">
                <a-input :placeholder="$t('请输入信号强度')" v-model="queryParam.signalLevel"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('信噪比')">
                <a-input :placeholder="$t('请输入信噪比')" v-model="queryParam.signalPre"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>

      </a-table>
    </div>
    <!-- 表单区域 -->
    <partMeter-modal ref="modalForm" @ok="modalFormOk"></partMeter-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import PartMeterModal from './modules/PartMeterModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import configService from '@/utils/service/config.service'

  export default {
    name: "PartMeterList",
    mixins:[JeecgListMixin],
    components: {
      PartMeterModal
    },
    data () {
      return {
        description: '上报管理管理页面',
	url: {
          list: "/model/partMeter/list",
          delete: "/model/partMeter/delete",
          deleteBatch: "/model/partMeter/deleteBatch",
          exportXlsUrl: "model/partMeter/exportXls",
          importExcelUrl: "model/partMeter/importExcel",
       },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${configService.apiUrl}/${this.url.importExcelUrl}`;
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:(t,r,index) => {
            return parseInt(index)+1;
          }
        },{
          title: this.$t('表类型'),
          align:"center",
          dataIndex: 'meterType',
          customRender:(text) => {
            let data = {'00': this.$t('小口径表'), '01': this.$t('大口径表'), '80': this.$t('平台计费水表'), '81': this.$t('阶梯计费水表'), '82': this.$t('表端计费水量表')}
            return data[text]
          }
        },{
          title: this.$t('设备ID'),
          align:"center",
          dataIndex: 'deviceId'
        },{
          title: this.$t('模组号'),
          align:"center",
          dataIndex: 'meterId'
        },{
          title: this.$t('信号强度'),
          align:"center",
          dataIndex: 'signalLevel'
        },{
          title: this.$t('信噪比'),
          align:"center",
          dataIndex: 'signalPre'
        },{
          title: this.$t('覆盖等级'),
          align:"center",
          dataIndex: 'signalCover'
        },{
          title: this.$t('小区ID'),
          align:"center",
          dataIndex: 'signalCell'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ]
    },
  },
    methods: {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>